import { isLocalPath } from './rentalPick';

/**
 * „Dodaj w katalogu dostawcy” (owner 2026-10-23 20:59: „pozwól przejść do katalogu tego dostawcy, aby dodać pozycję”):
 * the supplier's catalog opens with the new-position form already open and filled with our item. All in the address:
 * - `/katalog/dostawcy/<supplierId>?dodaj=item:<itemId>&powrot=<the page it came from>`;
 * - after saving, „Wróć” goes to `powrot` (a local address only: one „/”, never „//” nor „\”), where the supplier can be
 *   chosen again.
 */

const ID = /^[\w-]{1,64}$/;

/** The supplier's catalog with the form for `itemId` open; `back`: where „Wróć” goes after saving (path + query). */
export function supplierAddUrl(supplierId: string, itemId: string, back?: string): string {
  const q = new URLSearchParams({ dodaj: `item:${itemId}` });
  if (back && isLocalPath(back)) q.set('powrot', back);
  return `/katalog/dostawcy/${encodeURIComponent(supplierId)}?${q.toString()}`;
}

/** The deep link of the supplier's page: the item to fill the form with and where to go back (null: nowhere). */
export function parseSupplierAdd(params: URLSearchParams): { itemId: string; back: string | null } | null {
  const m = /^item:(.+)$/.exec(params.get('dodaj') ?? '');
  if (!m || !ID.test(m[1]!)) return null;
  const back = params.get('powrot');
  return { itemId: m[1]!, back: back && isLocalPath(back) ? back : null };
}

/**
 * Ctrl+klik on a supplier's line (owner 2026-10-23 20:53): `?edytuj=<priceId>` — or `?edytuj=item:<itemId>`, the
 * supplier's position of our item — opens that position's editor; `powrot` as above.
 */
export function parseSupplierEdit(params: URLSearchParams): ({ priceId: string } | { itemId: string }) & { back: string | null } | null {
  const raw = params.get('edytuj') ?? '';
  const back = params.get('powrot');
  const way = { back: back && isLocalPath(back) ? back : null };
  const m = /^item:(.+)$/.exec(raw);
  if (m) return ID.test(m[1]!) ? { itemId: m[1]!, ...way } : null;
  return ID.test(raw) ? { priceId: raw, ...way } : null;
}
